import { Button as ChakraButton, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { IoIosCloseCircle } from 'react-icons/io';

import {
  useJobFilters,
  JobFiltersType,
} from 'lib/repositories/jobsShowcaseFilters';

export interface RemoteProps {
  handleSearchJobs: (updatedFilters?: JobFiltersType) => void;
}

export const Remote = ({ handleSearchJobs }: RemoteProps) => {
  const { filters, setType } = useJobFilters();

  const isActive = useMemo(
    () => filters.type !== undefined && filters.type?.length > 0,
    [filters.type]
  );

  const handleFilter = () => {
    const type = isActive ? [] : ['remote'];
    setType(type);
    handleSearchJobs({ ...filters, type });
  };

  return (
    <>
      <ChakraButton
        bgColor={isActive ? 'primary.150' : 'white'}
        borderColor={isActive ? 'primary.500' : 'grey.100'}
        borderRadius={18}
        borderWidth={1}
        color={isActive ? 'primary.500' : 'text.700'}
        fontSize={14}
        fontWeight={600}
        _hover={{
          borderColor: isActive ? 'primary.500' : 'text.700',
        }}
        _focus={{
          borderColor: isActive ? 'primary.500' : 'text.700',
        }}
        rightIcon={
          isActive ? (
            <IoIosCloseCircle
              onClick={() => setType([])}
              style={{ width: '18px', height: '18px' }}
            />
          ) : (
            <></>
          )
        }
        onClick={handleFilter}
        px={3}
        py={2}
        flexShrink='0'
      >
        <Text mr={isActive ? '' : '-8px'}>Remoto</Text>
      </ChakraButton>
    </>
  );
};
